import { Lightbulb, Users, Rocket, Heart } from 'lucide-react';
import { ScrollReveal } from '@/hooks/useScrollReveal';
import { useTilt } from '@/hooks/useEffects';

const REASONS = [
  {
    icon: Lightbulb,
    title: 'Personal Approach',
    description: 'You work directly with me. No account managers, no juniors. One person who understands your project inside out.',
  },
  {
    icon: Users,
    title: 'Small Business Focus',
    description: 'I specialise in small businesses. I understand your challenges, your budget, and what actually moves the needle.',
  },
  {
    icon: Rocket,
    title: 'Built for Performance',
    description: 'Every site I build is optimised for speed, SEO, and conversions. Not just pretty — effective.',
  },
  {
    icon: Heart,
    title: 'Genuine Care',
    description: 'Your business matters to me. I invest time in understanding your goals and building something that truly helps.',
  },
];

function ReasonCard({ reason, i }) {
  const tilt = useTilt(5);
  return (
    <ScrollReveal delay={i * 100}>
      <div
        data-testid={`why-card-${i}`}
        ref={tilt.ref}
        onMouseMove={tilt.onMouseMove}
        onMouseLeave={tilt.onMouseLeave}
        className="tilt-card group relative bg-white dark:bg-[#111111] border border-slate-200 dark:border-white/10 rounded-2xl p-8 glow-hover"
      >
        <div className="w-10 h-10 rounded-lg bg-[#0A0A0A] dark:bg-[#8B5CF6]/20 flex items-center justify-center mb-5 group-hover:bg-[#00E5FF] dark:group-hover:bg-[#8B5CF6] transition-colors duration-300">
          <reason.icon className="w-4 h-4 text-white group-hover:text-white transition-colors" />
        </div>
        <h3 className="font-['Outfit'] text-lg font-semibold tracking-tight text-[#0A0A0A] dark:text-white mb-2">
          {reason.title}
        </h3>
        <p className="text-sm leading-relaxed text-slate-500 dark:text-slate-400">
          {reason.description}
        </p>
      </div>
    </ScrollReveal>
  );
}

export default function WhySection() {
  return (
    <section id="why" data-testid="why-section" className="py-24 md:py-32 bg-[#F8F9FA] dark:bg-[#0D0D0D]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <ScrollReveal>
          <span className="text-xs sm:text-sm font-bold uppercase tracking-[0.2em] text-slate-400 block mb-4">
            Why Work With Me
          </span>
          <h2 className="font-['Outfit'] text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#0A0A0A] dark:text-white mb-4 max-w-lg">
            Why Do Bournemouth Businesses Choose UI DESIGNS?
          </h2>
          <p className="text-base sm:text-lg leading-relaxed text-slate-600 dark:text-slate-400 mb-16 max-w-lg">
            Here is what makes working with us different — and why clients stay.
          </p>
        </ScrollReveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {REASONS.map((reason, i) => (
            <ReasonCard key={reason.title} reason={reason} i={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
